import Vue from 'vue'
import 'prismjs'
import 'prismjs/themes/prism-coy.css'
import Prism from 'vue-prism-component'
Vue.component('prism', Prism);
